var _path, _path2, _path3, _path4, _polygon, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-145"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.5,185.58a2.07,2.07,0,0,1,0-2.17c.11-.18.21-.37.31-.55s.2-.39.29-.58a2.1,2.1,0,0,1,1.79-1.21l2.67-.08-.27-8.68-2.66.08a2.06,2.06,0,0,1-1.88-1.09,11.67,11.67,0,0,0-.68-1.1,2.06,2.06,0,0,1-.13-2.15l1.25-2.34-7.65-4.11-1.26,2.34a2,2,0,0,1-1.87,1.08c-.43,0-.86,0-1.29,0a2.08,2.08,0,0,1-1.95-.95l-1.4-2.27-7.38,4.58,1.41,2.28a2,2,0,0,1,0,2.15c-.11.18-.21.37-.31.56s-.2.38-.29.57a2,2,0,0,1-1.8,1.21l-2.66.08L120,182l2.65-.09a2.1,2.1,0,0,1,1.88,1.09,10.65,10.65,0,0,0,.68,1.11,2,2,0,0,1,.14,2.15l-1.26,2.34,7.66,4.11,1.25-2.34a2.06,2.06,0,0,1,1.88-1.08,11.36,11.36,0,0,0,1.3,0,2.05,2.05,0,0,1,1.94,1l1.4,2.26,7.38-4.58Zm-13.7-2.18a7.11,7.11,0,1,1,9.63-2.91A7.11,7.11,0,0,1,131.8,183.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.12,290.62a4.51,4.51,0,0,1-1.75-4.37q.11-.67.18-1.38c0-.46.08-.93.11-1.39a4.45,4.45,0,0,1,2.6-3.9l5.28-2.36L644.85,260l-5.29,2.36a4.49,4.49,0,0,1-4.66-.65,24.82,24.82,0,0,0-2.27-1.65,4.47,4.47,0,0,1-2-4.22l.59-5.74-18.76-1.94-.6,5.74a4.48,4.48,0,0,1-2.87,3.71,25.61,25.61,0,0,0-2.56,1.15,4.5,4.5,0,0,1-4.7-.32L597,255.05l-11,15.28,4.71,3.41a4.48,4.48,0,0,1,1.74,4.34q-.1.69-.18,1.38c-.05.46-.08.93-.11,1.39a4.48,4.48,0,0,1-2.61,3.91l-5.29,2.36,7.69,17.22,5.27-2.36a4.46,4.46,0,0,1,4.66.64c.73.59,1.5,1.14,2.29,1.66a4.48,4.48,0,0,1,2.06,4.21l-.6,5.75,18.77,1.94.59-5.74a4.48,4.48,0,0,1,2.88-3.71,25.85,25.85,0,0,0,2.57-1.16,4.5,4.5,0,0,1,4.7.33l4.67,3.39L650.81,294Zm-29.33,6.92a15.45,15.45,0,1,1,17-13.78A15.46,15.46,0,0,1,616.79,297.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.79,64.47a3.14,3.14,0,0,1-1.54-2.92c0-.32,0-.65,0-1s0-.66,0-1a3.13,3.13,0,0,1,1.53-2.91l3.51-2-6.6-11.44-3.51,2a3.14,3.14,0,0,1-3.3-.11,16.77,16.77,0,0,0-1.7-1,3.14,3.14,0,0,1-1.73-2.79v-4H654.23v4a3.14,3.14,0,0,1-1.73,2.79,18.1,18.1,0,0,0-1.71,1,3.12,3.12,0,0,1-3.29.11l-3.51-2-6.61,11.44,3.53,2a3.12,3.12,0,0,1,1.53,2.9c0,.33,0,.65,0,1s0,.65,0,1a3.14,3.14,0,0,1-1.54,2.91l-3.52,2L644,77.93l3.5-2a3.12,3.12,0,0,1,3.29.11,18.1,18.1,0,0,0,1.71,1,3.14,3.14,0,0,1,1.74,2.79v4h13.22v-4A3.15,3.15,0,0,1,669.18,77a19.62,19.62,0,0,0,1.72-1,3.12,3.12,0,0,1,3.29-.11l3.5,2,6.6-11.44ZM660.84,71.4a10.82,10.82,0,1,1,10.82-10.82A10.83,10.83,0,0,1,660.84,71.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.11,127.29a3.16,3.16,0,0,1-1.54-2.92c0-.32,0-.65,0-1s0-.66,0-1a3.16,3.16,0,0,1,1.53-2.91l3.52-2L106,106l-3.51,2a3.14,3.14,0,0,1-3.29-.12,16.08,16.08,0,0,0-1.71-1,3.16,3.16,0,0,1-1.73-2.8v-4H82.55v4a3.16,3.16,0,0,1-1.73,2.8,16.08,16.08,0,0,0-1.71,1,3.14,3.14,0,0,1-3.29.12l-3.51-2-6.6,11.45,3.52,2a3.14,3.14,0,0,1,1.53,2.91c0,.32,0,.64,0,1s0,.65,0,1a3.14,3.14,0,0,1-1.54,2.92l-3.51,2,6.6,11.45,3.5-2a3.14,3.14,0,0,1,3.29.11,19.62,19.62,0,0,0,1.72,1,3.16,3.16,0,0,1,1.73,2.8v4H95.77v-4a3.15,3.15,0,0,1,1.74-2.8,18.1,18.1,0,0,0,1.71-1,3.14,3.14,0,0,1,3.29-.11l3.5,2,6.61-11.45Zm-19.94,6.94A10.83,10.83,0,1,1,100,123.4,10.83,10.83,0,0,1,89.17,134.23Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.73,233.05V377.5h87.32V233.05Zm7.92,53.54h71.47v37.6H79.65Zm0-46.56h71.47v37.6H79.65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.8,
    y: 233.05,
    width: 34.92,
    height: 144.45,
    transform: "translate(108.52 610.55) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.14,
    y: 240.02,
    width: 16.98,
    height: 37.6,
    transform: "translate(285.26 517.65) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.05,368.81H79.28v-36.6h71.77Zm-71-.75H150.3V333H80Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.09,
    y: 342.67,
    width: 14.11,
    height: 7.14,
    transform: "translate(236.28 692.47) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.4,349.64H106.54v-6.81H121.4Zm-14.11-.75h13.36v-5.31H107.29Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.14,
    y: 286.59,
    width: 16.98,
    height: 37.6,
    transform: "translate(285.26 610.78) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527.81,
    y: 55.29,
    width: 118.54,
    height: 79.88,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.84,135.67H527.31V54.79H646.84Zm-118.53-1H645.84V55.79H528.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.26,61.33a2.73,2.73,0,1,1-2.73-2.73A2.73,2.73,0,0,1,539.26,61.33Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.41,61.33a2.73,2.73,0,1,1-2.73-2.73A2.73,2.73,0,0,1,550.41,61.33Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.56,61.33a2.73,2.73,0,1,1-2.73-2.73A2.73,2.73,0,0,1,561.56,61.33Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527.81,
    y: 66.82,
    width: 118.54,
    height: 1,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-145"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 375,
    cy: 436.87,
    rx: 338.67,
    ry: 27.09,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-145"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M662.87,209.73s-23.53-3.3-18-31.7C644.84,178,671.13,183.93,662.87,209.73Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.87,209.73s-23.53-3.3-18-31.7C644.84,178,671.13,183.93,662.87,209.73Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.68,203.8a44.83,44.83,0,0,0-1.6-4.23c0-.19-.05-.37-.06-.54,0-.39-.07-.78-.1-1.17-.07-.85-.12-1.7-.17-2.55-.1-1.69-.21-3.39-.24-5.09a.07.07,0,0,0-.14,0c0,1.7,0,3.4,0,5.1,0,.85.08,1.7.13,2.55,0,.18,0,.37.05.56a51.28,51.28,0,0,0-4.72-8.07c-.81-1.13-1.66-2.21-2.57-3.26s-1.93-2.09-2.88-3.15c-.06-.07-.16,0-.1.1a41.67,41.67,0,0,1,4.53,6c.72,1.08,1.39,2.19,2,3.32l-.22-.09-.84-.34-1.92-.72c-1.26-.47-2.53-.93-3.79-1.41-.07,0-.12.1-.05.13,1.25.5,2.49,1,3.73,1.56l1.82.78c.3.14.61.26.92.38a2.29,2.29,0,0,0,.62.22c.48.86,1,1.71,1.38,2.58a60.14,60.14,0,0,1,2.87,6.78c.06.16.12.32.17.49a12.65,12.65,0,0,0-1.93-.93c-.81-.38-1.62-.74-2.43-1.11-1.65-.76-3.29-1.53-4.87-2.42-.08-.05-.15.08-.07.12,1.62.89,3.2,1.83,4.82,2.71.81.43,1.62.86,2.45,1.26a7.82,7.82,0,0,0,2.21.89,27.28,27.28,0,0,1,1.54,6.67c.27,3.21.24,6.45.31,9.67,0,.06.08,0,.09,0,.23-2.92.36-5.87.38-8.8A25.75,25.75,0,0,0,661.68,203.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.06,187.1a28,28,0,0,0-.24,5,0,0,0,0,0,.07,0c.1-1.66.11-3.31.31-5C658.21,187,658.07,187,658.06,187.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.33,188.52a18.12,18.12,0,0,1-3-1.49c-.07-.05-.14.08-.06.13a11.58,11.58,0,0,0,3,1.46C651.35,188.63,651.39,188.54,651.33,188.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.62,254.81c0-2.6-.07-5.2-.1-7.8,0-8.63-.12-17.26-.27-25.9q-.19-10.28-.48-20.55a.11.11,0,0,0-.06-.09l0-5.62s-.06-.07-.11-.07-.12,0-.12.08l0,5.62s-.06.05-.06.08c-.34,12.2-.65,24.4-.72,36.6,0,2.48,0,5,0,7.44q-.12,11.94-.09,23.86l0,3.8c0,7.28.08,14.56.08,21.83,0,.4.44.59.9.61s1.09-.19,1.09-.64c0-8,.05-16.05.05-24.07C663.64,264.93,663.66,259.87,663.62,254.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.79,246.91s-11.31-8.38-22-2.71-12.42,27.5-12.42,27.5,15.77,2.25,25.7-7.2C654.59,255.39,653.79,246.91,653.79,246.91Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.88,247.43a13.53,13.53,0,0,0-6.56-.85,9.22,9.22,0,0,0-1.38-.14l-1.6-.12-3.3-.23c-2.23-.17-4.47-.31-6.7-.53-.08,0-.09.13,0,.14,2.2.28,4.4.6,6.61.82,1.14.12,2.28.23,3.42.31l.82.09c-.34.07-.67.15-1,.24a27.2,27.2,0,0,0-5.13,2.09c-.89.16-1.78.41-2.65.61-1.4.33-2.79.69-4.19,1.06-2.74.72-5.46,1.53-8.19,2.32a.07.07,0,0,0,0,.14c2.73-.67,5.47-1.28,8.2-1.93l4-.95c.34-.09.69-.17,1-.24a33.1,33.1,0,0,0-8,7,43.76,43.76,0,0,0-5.59,8.81c0,.08.08.16.12.08a43,43,0,0,1,6.77-8.88l-.15.45-.63,2c-.42,1.34-.84,2.67-1.24,4,0,.09.11.11.14,0,.48-1.29.93-2.59,1.39-3.89.22-.64.44-1.27.67-1.91l.34-1a2.83,2.83,0,0,1,.11-.31,39.37,39.37,0,0,1,4-3.42,30.28,30.28,0,0,1,6-3.44l-.12.58c-.11.51-.23,1-.33,1.55-.22,1.07-.43,2.14-.64,3.22-.43,2.19-.69,4.4-1.1,6.59,0,.09.12.13.14,0,.51-2.2,1.16-4.37,1.65-6.58.25-1.1.49-2.21.72-3.31.11-.52.21-1,.32-1.56.06-.28.12-.57.16-.86.2-.08.4-.18.61-.25,3-1.1,6.25-1.9,9.42-1.29a9.27,9.27,0,0,1,6.81,5.45c.1.25.49.1.43-.16A8.77,8.77,0,0,0,656.88,247.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.56,256.76l-1,4.3a33.1,33.1,0,0,0-.79,4.18,0,0,0,0,0,.09,0,30.52,30.52,0,0,0,1-4.21l.84-4.25A.07.07,0,0,0,639.56,256.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.61,260.4c-1.44.73-2.83,1.56-4.34,2.16-.09,0,0,.18.06.13a46.38,46.38,0,0,0,4.32-2.23A0,0,0,0,0,628.61,260.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.34,231.52s-13.83.88-20.26-8.24-5-22.14-5-22.14,14.52,1.76,20.29,8.31S656.34,231.52,656.34,231.52Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.83,245.16c-.48-1.48-1.07-2.94-1.63-4.39s-1.11-2.78-1.72-4.14a85.46,85.46,0,0,0-4.15-8.15c-1-1.68-2-3.31-3.1-4.92,0-.25-.07-.49-.1-.74-.07-.43-.13-.85-.2-1.28-.13-.88-.29-1.75-.43-2.62-.32-1.91-.72-3.81-1-5.72,0-.09-.16-.09-.14,0,.28,1.89.47,3.79.73,5.67.13.93.25,1.86.39,2.79,0,.33.11.67.16,1a99.2,99.2,0,0,0-6.84-8.87c-.33-.38-.67-.76-1-1.13,0-.11-.09-.21-.13-.32l-.3-.79-.6-1.65c-.39-1.08-.74-2.18-1-3.29,0-.09-.16-.05-.14,0,.28,1.14.58,2.27.91,3.39.16.54.34,1.08.53,1.61,0,.09.06.18.1.27-1.77-1.93-3.61-3.79-5.48-5.62-.06-.07-.16,0-.1.1a98.2,98.2,0,0,1,9.8,12,7.26,7.26,0,0,0-1-.26c-1.07-.21-2.14-.36-3.21-.5-2.26-.29-4.5-.57-6.75-.92a.07.07,0,1,0,0,.14c2.14.42,4.26.9,6.39,1.39,1,.23,2,.43,3,.63a17.82,17.82,0,0,1,2.43.69c.23.32.46.63.68.95,1,1.48,2,3,2.94,4.51l-1.41-.28c-1.07-.2-2.14-.4-3.21-.57-2.11-.35-4.23-.72-6.31-1.19a.07.07,0,0,0,0,.14c2.11.49,4.21,1.07,6.3,1.63,1,.27,2,.52,3.06.74l1.54.34a3.79,3.79,0,0,0,.62.1c2,3.28,3.92,6.63,5.67,10.05q1.15,2.26,2.24,4.56c.74,1.57,1.37,3.17,2,4.76C662.44,245.64,662.94,245.51,662.83,245.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.67,213.38c-.26-1.32-.54-2.63-.83-3.95,0-.09-.16-.05-.14,0,.27,1.3.51,2.6.75,3.9a39,39,0,0,0,.78,3.87s0,0,0,0A26.5,26.5,0,0,0,648.67,213.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.61,213c-.64-.32-1.32-.58-2-.84l-1-.41-.53-.22a2.55,2.55,0,0,1-.59-.25c-.1-.08-.17.1-.06.12a2.71,2.71,0,0,1,.59.24l.52.24,1,.45a19.59,19.59,0,0,0,2,.8C640.63,213.16,640.68,213,640.61,213Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.49,220.64s8.37-15.63,21.11-18,20.52,10.68,20.52,10.68-9.28,11.86-21,13.93S670.49,220.64,670.49,220.64Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.13,209.6a34.49,34.49,0,0,0-10,.11l.57-.3c.95-.48,1.89-1,2.83-1.46,2-1,3.93-2.09,6-2.91.09,0,0-.18-.06-.13-2,.92-4.06,1.7-6.06,2.62-1,.46-2,.94-2.95,1.45-.63.34-1.33.65-1.94,1.05a34.88,34.88,0,0,0-8.1,2.69L682,211c1.18-1.3,2.35-2.66,3.65-3.84.07-.07,0-.16-.1-.1-1.33,1.21-2.74,2.33-4,3.59-.63.61-1.23,1.24-1.81,1.89-.29.33-.59.66-.86,1a33.49,33.49,0,0,0-17.07,23.05c0,.09.1.14.13,0a38.46,38.46,0,0,1,9.36-15.84,36.76,36.76,0,0,1,17.06-9.87,37.34,37.34,0,0,1,11.77-1.07A.13.13,0,0,0,700.13,209.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.13,213.27s-9.29,11.86-21,13.93c-8.91,1.58-16.25-3.07-19.22-5.36l-.65-1.05s6-5.08,17.43-8S712.13,213.27,712.13,213.27Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.74,204a31.45,31.45,0,0,0-2.83,1.87,18.09,18.09,0,0,0-2.46,2.25c-.06.07,0,.16.11.1.85-.73,1.7-1.47,2.57-2.16a26.85,26.85,0,0,1,2.68-1.94C692.89,204.1,692.81,204,692.74,204Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.72,206.67c-.47.2-1,.36-1.42.56l-1.42.59c-.1,0,0,.21,0,.16l1.42-.57c.48-.19.94-.41,1.41-.6C699.85,206.77,699.81,206.63,699.72,206.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.82,240.32s2.24,15.51,13.9,20.93,25.88,0,25.88,0S703,227.7,668.82,240.32Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.57,251.16c-1.08-.12-2.15-.3-3.21-.5l-1.57-.29-.82-.17c-.31-.29-.62-.59-.94-.87a47,47,0,0,0-7.14-5.17,39.09,39.09,0,0,0-4.27-2.2h.22l3.84.17c2.56.12,5.12.18,7.67.34.1,0,.09-.14,0-.14-2.57-.18-5.12-.46-7.68-.68l-3.73-.33-1.93-.17-.49,0q-1-.37-2-.69a18.16,18.16,0,0,0-9.88-.55c-2.93.75-5.86,2.67-6.62,5.77,0,.1.14.18.19.07,1.09-2.58,4-3.89,6.55-4.42a15.86,15.86,0,0,1,5.28-.11,12.07,12.07,0,0,0,.59,2.35c.32,1.09.64,2.18,1,3.27.66,2.18,1.39,4.34,2,6.52a.07.07,0,0,0,.14,0c-.54-2.18-1-4.38-1.52-6.56-.26-1.07-.53-2.13-.79-3.2a19.08,19.08,0,0,0-.59-2.21,27.62,27.62,0,0,1,3,.71,45.92,45.92,0,0,1,5.29,1.94c.17,1.11.42,2.2.67,3.29.32,1.37.68,2.73,1.11,4.07a.07.07,0,0,0,.13,0A2.38,2.38,0,0,1,685,251h0c-.26-1.27-.54-2.53-.8-3.8-.22-1-.42-2.05-.64-3.07q2.17,1,4.25,2.16c0,.31.11.64.15.92.09.54.18,1.07.28,1.59.22,1.2.46,2.39.74,3.58a58.61,58.61,0,0,0,2,6.74.08.08,0,0,0,0,.09l.07.08c0,.06.13,0,.12-.08-.54-2.29-1.16-4.57-1.66-6.88-.26-1.15-.51-2.3-.74-3.46-.12-.58-.22-1.16-.33-1.73,0-.17-.06-.34-.08-.52a49.77,49.77,0,0,1,4.54,3,48.57,48.57,0,0,1,7,6.34c.08.09.25,0,.17-.14a42.78,42.78,0,0,0-2.78-3.39c-.59-.63-1.2-1.23-1.82-1.83l.2,0c.54.1,1.09.18,1.64.25,1.08.15,2.16.25,3.24.37C700.62,251.31,700.66,251.18,700.57,251.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.37,256.42h0c0-.13,0-.27-.07-.4s-.11-.33-.14-.51h0c-.24-1-.44-2.08-.63-3.13,0-.07-.13,0-.13,0a12.85,12.85,0,0,0,.89,4s.09,0,.08,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.61,256.17a.07.07,0,0,0-.07-.06c-.33-1.37-.64-2.75-.92-4.13-.15-.73-.31-1.45-.45-2.18l-.21-1.18a3.48,3.48,0,0,0-.25-1c0-.05-.13,0-.13,0a6.75,6.75,0,0,0,.29,2.08c.14.76.29,1.51.45,2.27.34,1.53.73,3.05,1.16,4.56a.08.08,0,0,0,.15,0C682.63,256.4,682.62,256.29,682.61,256.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.5,246.7c-2.13-.29-4.26-.6-6.39-.86-.09,0-.13.13,0,.14,2.12.31,4.26.58,6.39.86C699.56,246.85,699.59,246.71,699.5,246.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.85,204s-7.14-31.31,26.5-44C689.35,160,698.67,201.18,662.85,204Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.11,186.19l.36-.22,1.9-1.06,3.9-2.18c2.57-1.44,5.11-2.93,7.69-4.34.08,0,0-.16-.07-.12-2.59,1.41-5.23,2.73-7.83,4.1l-3.86,2-1.57.83c1.12-2.12,2.32-4.21,3.63-6.22,1.76-2.68,3.69-5.24,5.69-7.73.09-.12-.06-.27-.16-.16a53.21,53.21,0,0,0-7.78,9.53c0-.11,0-.22,0-.32,0-.78.06-1.56.07-2.34,0-1.53-.05-3.06,0-4.59,0-.09-.14-.08-.14,0-.06,1.5-.24,3-.33,4.5,0,.75-.07,1.5-.1,2.26,0,.4,0,.86,0,1.31-.69,1.1-1.36,2.22-2,3.35a59.91,59.91,0,0,0-3,6.31c0-.78-.08-1.56-.12-2.34-.1-1.71-.31-3.42-.38-5.14a.08.08,0,0,0-.15,0c0,1.71,0,3.43,0,5.14,0,.86.06,1.72.11,2.57l.06,1a57.53,57.53,0,0,0-2.54,8.6,91.54,91.54,0,0,0-1.25,9.45s0,0,0,0A51.83,51.83,0,0,1,664,202c.41-1.47.85-2.94,1.33-4.4,1.4-.66,2.74-1.48,4.09-2.23s2.81-1.54,4.22-2.31c2.8-1.54,5.61-3.11,8.5-4.47.09,0,0-.16-.07-.12-2.94,1.33-5.89,2.59-8.77,4-1.43.72-2.84,1.49-4.24,2.27-1.17.66-2.37,1.32-3.49,2.08.33-1,.67-2,1-2.91C667.67,191.29,668.83,188.71,670.11,186.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.28,179a.08.08,0,0,0-.15,0c.12,1.78.18,3.57.37,5.35,0,.1.16.1.16,0C667.6,182.6,667.41,180.82,667.28,179Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.4,185c-2.1.85-4.23,1.66-6.32,2.53-.06,0,0,.12,0,.1,2.12-.8,4.22-1.66,6.33-2.49C683.53,185.12,683.49,185,683.4,185Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.6,170.57a55.35,55.35,0,0,0-6,3.21.09.09,0,0,0,.09.16c1.95-1.14,3.94-2.24,6-3.24C686.76,170.65,686.68,170.54,686.6,170.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 637.58,
    y: 271.65,
    width: 48.51,
    height: 51.13,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 634.24,
    y: 289.74,
    width: 2.48,
    height: 87.58,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.69,
    y: 289.74,
    width: 2.48,
    height: 87.58,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 661.79,
    y: 289.74,
    width: 2.48,
    height: 87.58,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 635.48,
    y: 319.5,
    width: 52.44,
    height: 7.08,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-145"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "36.33 377.32 121 376.94 205.66 376.8 375 376.53 544.34 376.8 629 376.93 713.67 377.32 629 377.71 544.34 377.85 375 378.11 205.66 377.85 121 377.71 36.33 377.32",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-145"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.19,
    y: 80.84,
    width: 465.35,
    height: 311.29,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.57,
    y: 84.63,
    width: 458.59,
    height: 303.69,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.58,
    y: 415.47,
    width: 586.57,
    height: 21.36,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.58 415.47 136.19 392.12 601.54 392.12 662.15 415.47 75.58 415.47",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.6 407.19 180.71 392.12 557.01 392.12 596.13 407.19 141.6 407.19",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.48,
    y: 107.71,
    width: 406.76,
    height: 257.55,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.48,
    y: 107.71,
    width: 406.76,
    height: 9.91,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.41,112.66a2,2,0,1,1-2-2A2,2,0,0,1,174.41,112.66Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.55,112.66a2,2,0,1,1-2-2A2,2,0,0,1,182.55,112.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.68,112.66a2,2,0,1,1-2-2A2,2,0,0,1,190.68,112.66Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.02,
    y: 138.46,
    width: 158.19,
    height: 110.78,
    transform: "translate(528.22 387.69) rotate(180)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.02,
    y: 138.46,
    width: 158.19,
    height: 110.78,
    transform: "translate(528.22 387.69) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.51,170a13.11,13.11,0,1,0,13.1-13.11A13.1,13.1,0,0,0,203.51,170Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.24 225.36 343.2 225.36 299.22 165.75 255.24 225.36",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.24 225.36 343.2 225.36 299.22 165.75 255.24 225.36",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.78 225.42 293.4 225.42 257.09 186.59 220.78 225.42",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.02,
    y: 225.36,
    width: 158.19,
    height: 23.87,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.71,
    y: 264.06,
    width: 88.39,
    height: 79.97,
    transform: "translate(819.8 608.09) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.12,281.55a9.47,9.47,0,1,0,7.43-7.43A9.48,9.48,0,0,0,377.12,281.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.59 326.8 454.1 326.8 422.34 283.76 390.59 326.8",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.71 326.84 418.14 326.84 391.92 298.81 365.71 326.84",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.71,
    y: 326.8,
    width: 88.39,
    height: 17.23,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.71,
    y: 138.46,
    width: 141.78,
    height: 7.15,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.71,
    y: 153.26,
    width: 172.61,
    height: 7.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.71,
    y: 168.07,
    width: 172.61,
    height: 7.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.71,
    y: 182.88,
    width: 172.61,
    height: 7.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.71,
    y: 197.69,
    width: 172.61,
    height: 7.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.71,
    y: 212.5,
    width: 114.59,
    height: 7.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.98,
    y: 264.06,
    width: 62.71,
    height: 7.04,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.98,
    y: 278.65,
    width: 76.34,
    height: 7.04,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.98,
    y: 293.23,
    width: 76.34,
    height: 7.04,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.98,
    y: 307.82,
    width: 76.34,
    height: 7.04,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.98,
    y: 322.4,
    width: 76.34,
    height: 7.04,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.98,
    y: 336.99,
    width: 51.81,
    height: 7.04,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.71,
    y: 228.2,
    width: 172.61,
    height: 21.03,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.02,
    y: 264.06,
    width: 158.19,
    height: 21.03,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.02,
    y: 292.74,
    width: 158.19,
    height: 7.11,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.02,
    y: 307.47,
    width: 158.19,
    height: 7.11,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.02,
    y: 322.2,
    width: 158.19,
    height: 7.11,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.02,
    y: 336.92,
    width: 108.38,
    height: 7.11,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 561.36,
    y: 117.62,
    width: 10.88,
    height: 247.64,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.79,247.22h0a2.8,2.8,0,0,1-2.8-2.81V122.88a2.8,2.8,0,0,1,2.8-2.81h0a2.81,2.81,0,0,1,2.81,2.81V244.41A2.81,2.81,0,0,1,566.79,247.22Z",
    style: {
      fill: "#a6a6a6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-145"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116.97,
    y: 58.91,
    width: 186.12,
    height: 117.42,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.97,
    y: 58.91,
    width: 186.12,
    height: 10.34,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.07,
    y: 89.82,
    width: 5.53,
    height: 2.02,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.63,
    y: 89.82,
    width: 89.31,
    height: 2.02,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.34,
    y: 89.82,
    width: 10.5,
    height: 2.02,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.15,
    y: 116.85,
    width: 10.5,
    height: 2.02,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.12,
    y: 89.82,
    width: 35.41,
    height: 2.02,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.6,
    y: 95.23,
    width: 5.53,
    height: 2.02,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.02,
    y: 95.23,
    width: 41.63,
    height: 2.02,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.9,
    y: 116.85,
    width: 15.75,
    height: 2.02,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.63,
    y: 111.45,
    width: 39.76,
    height: 2.02,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.02,
    y: 100.63,
    width: 27.89,
    height: 2.02,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.36,
    y: 106.04,
    width: 27.89,
    height: 2.02,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.01,
    y: 100.63,
    width: 70.42,
    height: 2.02,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.63,
    y: 116.85,
    width: 87.68,
    height: 2.02,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.95,
    y: 95.23,
    width: 46.07,
    height: 2.02,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.26,
    y: 95.23,
    width: 52.41,
    height: 2.02,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.78,
    y: 100.63,
    width: 17.9,
    height: 2.02,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.6,
    y: 100.63,
    width: 5.53,
    height: 2.02,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.07,
    y: 106.04,
    width: 5.53,
    height: 2.02,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.63,
    y: 106.04,
    width: 32.68,
    height: 2.02,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.02,
    y: 122.26,
    width: 32.68,
    height: 2.02,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.84,
    y: 127.66,
    width: 42.1,
    height: 2.02,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.35,
    y: 122.26,
    width: 58.65,
    height: 2.02,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.57,
    y: 127.66,
    width: 54.41,
    height: 2.02,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.02,
    y: 127.66,
    width: 9.46,
    height: 2.02,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.64,
    y: 111.45,
    width: 61.2,
    height: 2.02,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.12,
    y: 111.45,
    width: 39.73,
    height: 2.02,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.63,
    y: 106.04,
    width: 61.16,
    height: 2.02,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.07,
    y: 111.45,
    width: 5.53,
    height: 2.02,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.07,
    y: 116.85,
    width: 5.53,
    height: 2.02,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.6,
    y: 122.26,
    width: 5.53,
    height: 2.02,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.6,
    y: 127.66,
    width: 5.53,
    height: 2.02,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.07,
    y: 132.19,
    width: 5.53,
    height: 2.02,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.63,
    y: 132.19,
    width: 64.84,
    height: 2.02,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.6,
    y: 137.6,
    width: 5.53,
    height: 2.02,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.02,
    y: 137.6,
    width: 41.63,
    height: 2.02,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.63,
    y: 153.81,
    width: 39.76,
    height: 2.02,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.02,
    y: 143,
    width: 27.89,
    height: 2.02,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.01,
    y: 143,
    width: 70.42,
    height: 2.02,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.63,
    y: 159.22,
    width: 87.68,
    height: 2.02,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.95,
    y: 137.6,
    width: 46.07,
    height: 2.02,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.26,
    y: 137.6,
    width: 52.41,
    height: 2.02,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.78,
    y: 143,
    width: 17.9,
    height: 2.02,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.6,
    y: 143,
    width: 5.53,
    height: 2.02,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.07,
    y: 148.41,
    width: 5.53,
    height: 2.02,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.63,
    y: 148.41,
    width: 32.68,
    height: 2.02,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.64,
    y: 153.81,
    width: 61.2,
    height: 2.02,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.63,
    y: 148.41,
    width: 61.16,
    height: 2.02,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.07,
    y: 153.81,
    width: 5.53,
    height: 2.02,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.48,84.5a.49.49,0,0,1,0,.69.46.46,0,0,1-.33.13.51.51,0,0,1-.35-.13L128.67,83s0,0,0,0l0,0a.07.07,0,0,1,0-.06s0,0,0,0,0,0,0,0,0,0,0,0v-.06s0,0,0,0V82.6s0,0,0,0a.13.13,0,0,1,0-.06s0,0,0,0,0,0,0-.07a0,0,0,0,1,0,0,.12.12,0,0,1,0,0l2.13-2.17a.5.5,0,0,1,.68,0,.49.49,0,0,1,0,.69l-1.79,1.81Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.42,84.75l1.86-4.43a.42.42,0,0,1,.55-.22.41.41,0,0,1,.21.54l-1.86,4.43a.41.41,0,0,1-.38.25.25.25,0,0,1-.15,0A.4.4,0,0,1,133.42,84.75Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.72,83a0,0,0,0,1,0,0s0,0-.06,0l-2.13,2.17a.51.51,0,0,1-.68,0,.49.49,0,0,1,0-.69l1.8-1.81-1.8-1.81a.49.49,0,0,1,0-.69.5.5,0,0,1,.68,0l2.13,2.17s0,0,.06,0a0,0,0,0,1,0,0s0,0,0,.07,0,0,0,0a.64.64,0,0,1,0,.07s0,0,0,0v.09s0,0,0,0v.06h0s0,.06,0,.07,0,0,0,0S139.73,82.93,139.72,83Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.39,64.15a2.27,2.27,0,1,1-2.27-2.27A2.27,2.27,0,0,1,126.39,64.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.38,
    cy: 64.15,
    r: 2.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.92,64.15a2.27,2.27,0,1,1-2.27-2.27A2.27,2.27,0,0,1,144.92,64.15Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bugs--inject-145"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.68,160.21,456.5,176.5s.54.59,1.51,1.46c.35.3.74.64,1.17,1a29.4,29.4,0,0,0,3.43,2.46l1.36.78a17.29,17.29,0,0,0,3.78,1.49,10.4,10.4,0,0,0,1.73.35,9.77,9.77,0,0,0,10.63-11.4,12.17,12.17,0,0,0-.46-1.72,17.81,17.81,0,0,0-1.76-3.65c-.29-.44-.59-.88-.88-1.3a27.69,27.69,0,0,0-2.7-3.25c-.38-.41-.74-.77-1.07-1.08C472.31,160.71,471.68,160.21,471.68,160.21Zm4.24,18.28-.89.95-10-9.29.88-1Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.49,159l-15.25,16.37c-3.2-3-3-9.22,1.41-14S467.29,156,470.49,159Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "460.16 177.88 457.23 181.03 451.34 179.7 451.68 178.22 456.71 179.36 459.05 176.85 460.16 177.88",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.16,
    y: 182.46,
    width: 7.61,
    height: 1.52,
    transform: "translate(12.97 396.25) rotate(-47.02)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "467.65 190.33 466.14 190.46 465.74 185.84 469.15 182.17 470.26 183.21 467.31 186.38 467.65 190.33",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "476.26 160.61 473.32 163.76 472.21 162.72 474.55 160.21 473.06 155.27 474.51 154.83 476.26 160.61",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 474.97,
    y: 164.43,
    width: 7.61,
    height: 1.52,
    transform: "translate(31.51 402.81) rotate(-47.02)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.27 170.35 482.3 170.29 479.35 173.46 478.24 172.42 481.65 168.76 486.29 168.84 486.27 170.35",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "457.79 166.57 448.89 166.89 444.46 162.76 445.49 161.65 449.46 165.35 457.74 165.06 457.79 166.57",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "461.88 162.19 460.36 162.24 460.07 153.97 456.1 150.27 457.13 149.16 461.56 153.28 461.88 162.19",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.91,307.55l-18.13-8.12s-.35.64-.8,1.7c-.15.38-.32.81-.49,1.28a24.14,24.14,0,0,0-1.09,3.6c-.1.44-.19.91-.27,1.37A15.7,15.7,0,0,0,227,311a8.71,8.71,0,0,0,12.9,7.25,10.91,10.91,0,0,0,1.32-.89,15.84,15.84,0,0,0,2.57-2.54c.29-.37.58-.75.84-1.11a25.07,25.07,0,0,0,2-3.22c.24-.44.45-.85.61-1.22A17.82,17.82,0,0,0,247.91,307.55ZM233.7,316.4l-1.06-.47,5-11.1,1.06.48Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.57,306.2l-18.22-8.15c1.59-3.56,6.9-5.22,12.21-2.84S250.16,302.64,248.57,306.2Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.67 302.93 226.16 301.36 225.59 296 226.94 295.86 227.43 300.44 230.22 301.69 229.67 302.93",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.01,
    y: 302.6,
    width: 1.35,
    height: 6.79,
    transform: "translate(-145.8 386.99) rotate(-65.89)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.32 312.84 220.78 311.6 224.56 309.93 228.64 311.75 228.09 312.99 224.56 311.41 221.32 312.84",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.89 311.53 245.38 309.96 245.94 308.72 248.73 309.98 252.47 307.29 253.26 308.39 248.89 311.53",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.07,
    y: 311.58,
    width: 1.35,
    height: 6.79,
    transform: "translate(-142.13 410.61) rotate(-65.89)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.55 322.79 242.46 319.42 238.94 317.84 239.49 316.61 243.57 318.43 244.84 322.37 243.55 322.79",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.53 297.66 235.69 290.24 237.9 285.31 239.14 285.86 237.16 290.28 239.79 297.18 238.53 297.66",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.41 299.85 242.93 298.58 249.83 295.95 251.8 291.53 253.04 292.08 250.83 297.01 243.41 299.85",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.68,319.67,451.39,336s.56.45,1.53,1.1c.34.21.73.46,1.16.71a25.3,25.3,0,0,0,3.35,1.73l1.3.52a15.8,15.8,0,0,0,3.52.82,9.3,9.3,0,0,0,1.58.08,8.71,8.71,0,0,0,7.9-11.44,10.37,10.37,0,0,0-.63-1.46,15.29,15.29,0,0,0-2-3c-.32-.35-.63-.71-.94-1a24.77,24.77,0,0,0-2.81-2.52c-.39-.31-.75-.59-1.09-.82A18.48,18.48,0,0,0,462.68,319.67Zm6.11,15.58-.66,1-10-6.91.66-.95Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.47,318.78,450.14,335.2c-3.21-2.21-3.88-7.74-.58-12.52S458.26,316.56,461.47,318.78Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "454.81 336.76 452.62 339.92 447.26 339.51 447.36 338.16 451.95 338.51 453.69 335.99 454.81 336.76",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 453.7,
    y: 340.56,
    width: 6.79,
    height: 1.35,
    transform: "translate(-83.39 523.59) rotate(-55.39)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.03 346.77 461.71 347.09 460.76 343.06 463.29 339.38 464.41 340.15 462.21 343.33 463.03 346.77",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "466.77 319.43 464.59 322.59 463.47 321.82 465.21 319.3 463.25 315.13 464.48 314.56 466.77 319.43",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.19,
    y: 322.47,
    width: 6.79,
    height: 1.35,
    transform: "translate(-63.11 526.05) rotate(-55.39)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "476.87 326.73 473.36 327.19 471.16 330.37 470.05 329.6 472.58 325.92 476.69 325.39 476.87 326.73",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "451.24 327.09 443.43 328.53 438.98 325.46 439.75 324.34 443.73 327.09 451 325.76 451.24 327.09",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "454.28 322.69 452.95 322.94 451.62 315.67 447.63 312.92 448.4 311.81 452.85 314.88 454.28 322.69",
    style: {
      fill: "#FFC727"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-145"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M574.37,168.73c14.72,8.33,41.51,33.66,39.54,40.71-4,14.2-21.75,33.78-26.49,37.63-2.75,2.24-24.76-15.61-22.17-18.38,3-3.24,21.81-20.76,21.85-22.49,0-1.31-10.69-15.4-18.6-27.38C559.33,164.91,567.35,164.76,574.37,168.73Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.16,226.8s-9.08,5.84-14.83,9.94c-3.21,2.28-8.37,6.69-10,9.45-2.38,4.13-9.7,22.9-5.18,24.78,4.08,1.69,8.32-15.24,8.32-15.24s-5.78,16.71-.49,17.84,7.54-18.63,7.54-18.63-5.56,17.3.09,17.61C557.91,272.78,561,255,561,255s-4.68,14.9-.3,15.33c4.83.48,8.67-15.77,8.67-15.77,11.31-.78,18-5.28,20.14-11.07C589.89,242.32,568.16,226.8,568.16,226.8Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.14,249.83c-.75,1.93-1.52,3.89-2.1,5.89s-1.08,4-1.47,6.06a35.48,35.48,0,0,0-.75,8.09c.25-4.83,2.2-12,2.78-14s1-4,1.62-6A0,0,0,0,0,548.14,249.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.39,251.77c-.85,2.52-1.78,5-2.52,7.54s-1.22,5-1.78,7.6c0,.2.08.16.13,0,.66-2.56,1.47-4.88,2.17-7.43s1.28-5.13,2.07-7.65C555.47,251.75,555.41,251.74,555.39,251.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.92,252.33a59.37,59.37,0,0,0-3,11.82c0,.2.12.12.17-.08.91-3.94,1.61-7.05,2.95-11.69C562.07,252.31,562,252.25,561.92,252.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.73,223.77l22,22.6s24.78-29.3,23.26-38.7-25.73-31.55-39-38.88-14.35.18-8.46,10.08,18.77,27.37,18.52,27.86S569.73,223.77,569.73,223.77Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.63,230.63c-1.57-1.48-3.11-3-4.64-4.5-.74-.72-1.49-1.44-2.2-2.19s-1.62-1.57-2.33-2.43c-.05-.06,0-.13.08-.09.9.66,1.71,1.47,2.56,2.18s1.55,1.37,2.32,2.06c1.6,1.45,3.2,2.89,4.77,4.37,3.13,3,6.17,6,9.19,9.1a.08.08,0,0,1-.11.12C591,236.43,587.78,233.58,584.63,230.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.54,178.87c5.88,9.91,18.77,27.38,18.52,27.86s-16.33,17-16.33,17l22,22.61s11.46-13.56,18.32-25.2l-44.32-54.89C563,167.75,564,172.87,567.54,178.87Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.52,389s1,40.78,1,40.81c0,7.54-.18,14.14-.58,17.56v.05a5.27,5.27,0,0,1-.57,2.33s0,0,0,0c-2.25,1.52-62.49,3.08-64.61,2.43s-.43-6.75,1.86-8.67,25.1-12.84,25.1-12.84L572.05,390Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.62,421.74s-.07,8.06-.07,8.09c0,7.54-.18,14.14-.58,17.56v.05a10.62,10.62,0,0,1-.57,2.33s0,0,0,0c-2.25,1.52-62.49,3.08-64.61,2.43s-.43-6.75,1.86-8.67,25.1-12.84,25.1-12.84l-.05-8.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569,430.75c4-.66,8.88.06,11.88,3,.11.11,0,.27-.18.23a56.31,56.31,0,0,0-11.7-2.7A.25.25,0,0,1,569,430.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.1,432.43c4-.66,8.88.05,11.87,3,.12.11,0,.27-.17.23a56.46,56.46,0,0,0-11.7-2.7A.25.25,0,0,1,566.1,432.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.17,434.1c4-.66,8.89.06,11.88,3,.12.12,0,.28-.17.23a56.43,56.43,0,0,0-11.7-2.69A.26.26,0,0,1,563.17,434.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.75,452.24c2.12.65,62.36-.91,64.61-2.43.87-.56,1.15-9.35,1.19-20v-.33l-38.88.57,0,.66s-22.79,10.91-25.1,12.84S543.62,451.59,545.75,452.24Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.55,429.49v.35c0,10.62-.32,19.41-1.19,20s-14.08,1.39-28.19,1.9c-16.88.59-35.27.89-36.42.53-2.13-.65-.42-6.75,1.86-8.67s25.1-12.84,25.1-12.84l0-.65,13-.2Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.37,449.89c10.15-.52,51.12-1.63,61.19-1.36.09,0,.09.05,0,.06-10,.73-51,1.51-61.19,1.46C546.16,450.05,546.15,449.9,546.37,449.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.64,429.88c-1,6.51-2.4,16.11-3.47,21.83-16.88.59-35.27.89-36.42.53-2.13-.65-.42-6.75,1.86-8.67s25.1-12.84,25.1-12.84l0-.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.06,430.05l-43.6.42s-2.47-71-2.66-94.65c-.21-27,1.32-108.13,1.32-108.13h32.59s8.75,17.87,3.75,38L605.08,338Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.82,422.42a30.82,30.82,0,0,0-3.47-.28c-1.29-.09-2.57-.19-3.86-.24q-3.72-.15-7.44-.16c-5,0-10,0-15,.18-2.84.09-5.69.2-8.53.36-.11,0-.11.18,0,.18,5,.18,9.93.26,14.89.36s9.93.19,14.88.09c1.43,0,2.85,0,4.27-.12s2.88,0,4.27-.2C611.89,422.57,611.92,422.44,611.82,422.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.6,383.24q-.75-17.6-1.2-35.22-1-35.24-.51-70.48c.17-13.18.52-26.35.91-39.53,0-.15-.22-.14-.23,0-1.25,23.58-1.72,47.22-1.75,70.83s.46,47,1.62,70.47c.65,13.17,1.46,26.35,2.7,39.48a.09.09,0,0,0,.18,0C575.79,406.94,575.12,395.1,574.6,383.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.89,395.5s-.34,39.42-.34,39.44c0,7.54-.18,14.15-.57,17.56a.07.07,0,0,1,0,.05,5.12,5.12,0,0,1-.57,2.33.1.1,0,0,1,0,.05c-2.25,1.51-62.49,3.07-64.61,2.42s-.42-6.74,1.87-8.67,25.09-12.84,25.09-12.84l.71-39.39Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.62,426.85s-.07,8.07-.07,8.09c0,7.54-.18,14.15-.57,17.56a.07.07,0,0,1,0,.05,10.27,10.27,0,0,1-.57,2.33.1.1,0,0,1,0,.05c-2.25,1.51-62.49,3.07-64.61,2.42s-.42-6.74,1.87-8.67,25.09-12.84,25.09-12.84l0-8.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521,435.86c4-.66,8.89.06,11.88,3,.11.11,0,.28-.18.23a56.29,56.29,0,0,0-11.7-2.69A.26.26,0,0,1,521,435.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.1,437.54c4-.66,8.88.06,11.88,3,.11.11-.05.27-.18.23a55.66,55.66,0,0,0-11.7-2.69A.26.26,0,0,1,518.1,437.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.18,439.22c4-.66,8.88,0,11.88,3,.11.11,0,.27-.18.23a56.46,56.46,0,0,0-11.7-2.7A.25.25,0,0,1,515.18,439.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.75,457.35c2.12.66,62.36-.91,64.61-2.42.87-.56,1.15-9.36,1.19-20v-.33l-38.87.57,0,.66s-22.79,10.92-25.09,12.84S495.63,456.71,497.75,457.35Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.37,455c10.15-.51,51.13-1.62,61.2-1.36.08,0,.08.06,0,.06-10.05.73-51,1.51-61.19,1.47C498.16,455.16,498.16,455,498.37,455Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.8,269.41s-17.88,56.36-18.2,66.73c-.28,8.83.85,99.45.85,99.45l-45.27.27s3.82-92.42,4.53-101.62c1.32-17.21,16.4-64.46,27.18-106.55H601.7s-.43,22-10.45,38C591.25,265.67,586.71,267.78,583.8,269.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.05,427.25c-5.23-.15-10.66-.31-15.89-.18s-10.39.21-15.57.52c-2.94.17-5.87.27-8.8.56a.08.08,0,0,0,0,.16c5.23.3,10.48.24,15.71.2s10.38-.11,15.57-.34c2.94-.14,5.87-.29,8.81-.49C564.19,427.66,564.36,427.26,564.05,427.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.15,254.25c-1.62,5.38-3,10.85-4.42,16.28s-2.91,11-4.35,16.44c-2.79,10.6-5.55,21.22-7.64,32a193.13,193.13,0,0,0-3.62,32.78c-.24,11.23,0,22.46.07,33.69s.17,22.56.36,33.85c0,1.4.06,2.8.11,4.21a.11.11,0,0,0,.21,0c.3-11.22.14-22.47.1-33.69s-.18-22.46-.08-33.69a202.45,202.45,0,0,1,2.87-33.25c1.9-10.8,4.56-21.45,7.32-32.06,1.57-6.05,3.16-12.1,4.73-18.15s3.27-12.17,4.66-18.31A.16.16,0,0,0,554.15,254.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.61,270.5a41,41,0,0,0,6.72-.61,66.78,66.78,0,0,0,6.51-1.81,50.94,50.94,0,0,1,6.39-1,22.39,22.39,0,0,0,6.26-1.87c.09,0,.17.1.08.14a38.89,38.89,0,0,1-6,2.61c-2.15.67-4.39.77-6.57,1.3a53.27,53.27,0,0,1-6.7,1.54,24.39,24.39,0,0,1-6.72-.11C572.5,270.63,572.52,270.5,572.61,270.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.75,315.34c.43-1.67.83-3.35,1.29-5,.91-3.37,1.84-6.73,2.86-10.07,2-6.63,3.93-13.3,6.07-19.89,1.21-3.74,2.3-7.53,3.72-11.2a.07.07,0,0,1,.14.05c-.71,3.42-1.72,6.76-2.63,10.13s-1.88,6.72-2.85,10.08c-1.93,6.65-3.82,13.33-5.93,19.93-.59,1.85-1.2,3.7-1.83,5.53s-1.17,3.82-2,5.64a.09.09,0,0,1-.17,0C568.78,318.74,569.31,317.05,569.75,315.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.64,177.5c3.3.06,8.25-6.45,9.53-10.8a66.44,66.44,0,0,0-2-6.39c-.65-2-1.33-4.33-1.79-6.47L549.68,160a34.93,34.93,0,0,1,3.08,7.92,5.64,5.64,0,0,1,.1.89.86.86,0,0,0,0,.15C553,170.69,553.45,177.44,556.64,177.5Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.86,168.82a.81.81,0,0,0,0,.15,8.41,8.41,0,0,0,1.4-.22c7.81-2,8-11.31,7.73-14.73l-12.32,6a35,35,0,0,1,3.08,7.91A6,6,0,0,1,552.86,168.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.53,137.7c2.18,4.58,1.72,18.85-1.24,22.46-4.28,5.23-12.33,6.87-17,1.48-4.56-5.22-3.63-23.8-.23-27.18C549,129.47,559.3,130.92,562.53,137.7Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.71,148.18s.07,0,.07.09c0,1,.07,2.07.94,2.4,0,0,0,.06,0,.05C549.65,150.56,549.51,149.09,549.71,148.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.58,147.19c1.55-.09,1.63,3,.19,3.1S549.29,147.27,550.58,147.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.31,148.3s-.07,0-.07.09c0,1,0,2.07-.91,2.41,0,0,0,.06,0,0C544.4,150.68,544.52,149.21,544.31,148.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.43,147.32c-1.55-.08-1.59,3-.16,3.1S544.73,147.39,543.43,147.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.92,146.2a11,11,0,0,1-1.26.2,2.05,2.05,0,0,1-1.32,0,.64.64,0,0,1-.29-.74,1.62,1.62,0,0,1,1.36-.94,2.39,2.39,0,0,1,1.7.25A.7.7,0,0,1,551.92,146.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.19,145.79c.43-.08.81-.23,1.23-.35a2.06,2.06,0,0,0,1.18-.6.66.66,0,0,0-.06-.8,1.62,1.62,0,0,0-1.63-.26,2.42,2.42,0,0,0-1.44.95A.7.7,0,0,0,542.19,145.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.94,156.89c-.22.23-.44.55-.79.59a2.7,2.7,0,0,1-1-.22,0,0,0,0,0,0,.05,1.3,1.3,0,0,0,1.23.49,1,1,0,0,0,.74-.87C551.05,156.88,551,156.86,550.94,156.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.86,154a3.24,3.24,0,0,1-2.15,1.51,3.83,3.83,0,0,1-1.17.08.86.86,0,0,1-.23,0l-.21,0a.27.27,0,0,1-.2-.21h0a.34.34,0,0,1,0-.1h0v-.08c0-.74,0-1.87,0-1.87-.26.14-1.63.8-1.61.41a48.94,48.94,0,0,1,1-9.93.09.09,0,0,1,.18,0c0,3.08-.52,6.15-.55,9.25a5.5,5.5,0,0,1,1.53-.51c.11,0-.12,2.18-.08,2.51v0a4.54,4.54,0,0,0,3.36-1.13C549.84,153.9,549.92,154,549.86,154Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.87,136.39a1.52,1.52,0,0,1,1.75-.44c1,.4,1,1.53,2.58,2s5.08-2.81,8.27-1.93,4,4.68,4.18,7.56,2,7.21,4.08,7.25c.42-5,.08-10.47-1.1-13-3.16-6.8-13.5-8.4-18.55-3.46A6.69,6.69,0,0,0,542.87,136.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.25,149.46s2.57-4.91,4.76-4.05.66,7.69-1.62,8.89a2.45,2.45,0,0,1-3.44-.89Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.52,147.36s.05,0,0,.06a6.23,6.23,0,0,0-2.69,4.27,1.36,1.36,0,0,1,2-.63s0,.1,0,.1a1.51,1.51,0,0,0-1.58.73,7.63,7.63,0,0,0-.62,1.44c-.06.16-.34.11-.3-.07v0C562,151.08,563.24,147.87,565.52,147.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.62,140.31s2.23-14.81,15.46-12.93,11.23,16.73,11.23,16.73Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 538.49,
    y: 141.15,
    width: 28.97,
    height: 2.12,
    transform: "matrix(0.99, 0.14, -0.14, 0.99, 25.57, -76.54)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "552.91 141.13 546.93 140.28 550.41 125.94 556.38 126.79 552.91 141.13",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "552.91 141.13 546.93 140.28 550.41 125.94 556.38 126.79 552.91 141.13",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "567.25 166.59 566.55 161.28 551.88 169.73 551.45 174.94 567.25 166.59",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.56,237.77c-.11.19-61.77,12.82-62.46,12.3-1-.73-4.24-63.46,5.44-77.44,2.39-3.44,11.62-8.29,15-6.69,8.83,4.14,15.21,15.07,19.23,21.39,3,4.68,7,12.85,10.91,21.29C604.09,222.51,610,237.09,609.56,237.77Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558,170.89c9,.76,6.79,26.46-3.56,25.58S549,170.13,558,170.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546,235.94c0,.64,0,1.25.06,1.85l59-12.13-.71-1.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.19,239.68c0,.64.07,1.25.1,1.84l60.29-12.37c-.22-.55-.45-1.13-.7-1.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 478.83,
    y: 189.32,
    width: 5.47,
    height: 31.9,
    transform: "translate(1005.01 199.24) rotate(156.25)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "490.73 236.39 498.3 233.06 498.3 233.06 489.33 212.66 489.33 212.66 481.76 215.99 481.76 215.99 490.73 236.39",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.84,191.39a26.12,26.12,0,1,1,35.59-9.93A26.15,26.15,0,0,1,451.84,191.39Zm1.47-2.61a23.13,23.13,0,1,0-8.8-31.51A23.16,23.16,0,0,0,453.31,188.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.5,170.72a27,27,0,1,1-.93-9.32A27.11,27.11,0,0,1,491.5,170.72Zm-52.11-4.06a25.46,25.46,0,0,0,.87,8.78,25.35,25.35,0,0,0,46.49,5.64,25.35,25.35,0,1,0-47.36-14.42Zm49.12,3.82a23.93,23.93,0,0,1-35.58,19h0a23.87,23.87,0,1,1,35.58-19ZM453.69,188.1a22.39,22.39,0,1,0-10.54-13.46,22.38,22.38,0,0,0,10.54,13.46Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444,160.57a22.23,22.23,0,1,0,28.78-12.66A22.24,22.24,0,0,0,444,160.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.52,166.7a22.23,22.23,0,0,0,20,24.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.48,148.39l27.42,33a22.07,22.07,0,0,0,2.48-4.66,21.73,21.73,0,0,0,1.41-5.88l-20.24-24.33A22.22,22.22,0,0,0,455.48,148.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.86,158.55,471,189.94a22.8,22.8,0,0,0,4-1.64l-27.81-33.43A21.52,21.52,0,0,0,444.86,158.55Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.81,149.84,481,183.72c.19-.2.36-.4.54-.6l-28-33.7A7.92,7.92,0,0,0,452.81,149.84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.76,148.34l12.51,15c-.16-.65-.35-1.29-.56-1.92l-10.18-12.23C475,148.91,474.37,148.62,473.76,148.34Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M455,183.74a17.77,17.77,0,0,1-5.34-4.92,18.6,18.6,0,0,1-1.89-3.19,19.77,19.77,0,0,1-1.21-3.52,17.59,17.59,0,0,1-.08-7.4,19.09,19.09,0,0,1,2.79-6.72,34.76,34.76,0,0,0-1.59,6.9,21.2,21.2,0,0,0-.08,3.47,17.73,17.73,0,0,0,.47,3.4,22.54,22.54,0,0,0,2.59,6.39A30.08,30.08,0,0,0,455,183.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.3,185c-1.86,16.4-6.92,28.58-17,34.67-10.64,6.46-42.72,4.13-50.89,3.62-3.46-.22,2.8-24.77,6.45-25.44s31.56,1.74,34.15.74,8.15-5.63,15.12-18.27C555.36,165.44,560.82,171.66,559.3,185Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.51,200.63a3.94,3.94,0,0,0,1.41,4.27,5.87,5.87,0,0,0-2,3.42c-.34,2.38,3.24,4,3.24,4a7.23,7.23,0,0,0-1.57,3.94c-.1,2.32,3.29,4.43,3.29,4.43a6.32,6.32,0,0,0,.8,4.34c2.22,3.4,8.42,3.27,12.37,3.23s15.08-3.85,17.28-4.36l.11-26s-13.09-4.77-22.51-3.46C475,195,467.5,197.72,466.51,200.63Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.09,204.5c4-1.63,8.25-2,12.48-2.59.09,0,.11.14,0,.15-4.21.55-8.26,1.92-12.45,2.63A.1.1,0,0,1,468.09,204.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.2,212a11.42,11.42,0,0,1,2.91-.47c1-.1,2.07-.17,3.11-.23,2.08-.12,4.17-.19,6.25-.21.1,0,.12.14,0,.15q-3.11.18-6.21.49c-1,.1-2.07.22-3.1.34a13.86,13.86,0,0,1-2.94.21A.15.15,0,0,1,469.2,212Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.93,220.65a8,8,0,0,1,2.63-.28q1.43,0,2.85-.12c1.9-.09,3.8-.18,5.69-.34a.08.08,0,0,1,0,.15c-1.92.17-3.84.36-5.77.52l-2.83.21a7.5,7.5,0,0,1-2.59,0S470.89,220.67,470.93,220.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.65,197.4l-3.45,30.12s37.2.06,45.95-9.31a54.12,54.12,0,0,0,14-35.84c.17-13.3-6.57-15-13-3.08a56.4,56.4,0,0,1-15,17.93C531.6,197.83,503.65,197.4,503.65,197.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.21,212.17c.18-2.15.41-4.29.64-6.44.12-1,.22-2.06.36-3.08s.23-2.25.46-3.34c0-.07.12-.07.12,0,0,1.11-.09,2.25-.12,3.36s-.11,2.07-.18,3.1c-.14,2.15-.28,4.3-.47,6.45-.38,4.3-.88,8.57-1.44,12.85a.08.08,0,0,1-.16,0C507.61,220.76,507.85,216.47,508.21,212.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.39,206.78a56.56,56.56,0,0,0,1.6-5.44c.49-1.79,1-3.57,1.47-5.36,1-3.59,2-7.2,3-10.8,0,0,.06,0,.06,0-.33,2.23-.76,4.44-1.26,6.63.06-.14.11-.29.17-.43.39-.88.8-1.74,1.21-2.6,0,0,.11,0,.09,0-.34.92-.67,1.84-1,2.74-.24.57-.5,1.13-.76,1.69-.24,1-.48,1.9-.74,2.84-.5,1.82-1.07,3.63-1.7,5.41s-1.4,3.52-1.94,5.32C554.5,206.92,554.35,206.87,554.39,206.78Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tools--inject-145"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.75,
    y: 389.62,
    width: 3.33,
    height: 52.1,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.85 418.33 116.1 417.37 117.54 416.71 116.82 415.31 118.26 414.64 117.54 413.24 118.98 412.58 118.27 411.18 119.7 410.52 118.99 409.11 120.42 408.45 119.71 407.04 121.15 406.38 120.43 404.98 121.87 404.32 121.16 402.91 122.59 402.26 121.88 400.85 123.31 400.19 122.6 398.78 124.03 398.12 123.32 396.72 124.75 396.06 124.04 394.65 125.47 394 124.76 392.59 126.2 391.93 125.48 390.52 126.92 389.86 126.21 388.45 127.64 387.8 126.93 386.39 128.37 385.73 127.65 384.33 129.09 383.67 128.37 382.26 129.81 381.6 129.09 380.19 130.53 379.54 129.82 378.13 131.25 377.47 130.54 376.07 131.97 375.41 131.26 374 132.69 373.34 131.98 371.93 133.42 371.27 132.7 369.87 134.14 369.21 133.43 367.8 134.86 367.15 134.15 365.74 135.58 365.08 134.87 363.67 137.62 364.63 118.85 418.33",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.19,
    y: 356.97,
    width: 12.12,
    height: 2.93,
    transform: "translate(522.23 346.18) rotate(109.26)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.85,418.33l.73-2.09,10.24,3.58a1.94,1.94,0,0,0,2.47-1.19l16.39-46.91a1.93,1.93,0,0,0-1.19-2.46l-10.22-3.58.73-2.08,10.22,3.57a4.15,4.15,0,0,1,2.55,5.28l-16.4,46.91a4.15,4.15,0,0,1-5.28,2.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.95,
    y: 389.62,
    width: 3.33,
    height: 52.1,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.08,
    y: 393.77,
    width: 68.04,
    height: 2.68,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.19,384.15l18-3.9L90,361l-18,3.9Zm1.25-6.58-2.37-10.89L88,363.88l2.36,10.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.1 430.04 98.07 430.03 99.19 429.43 99.18 429.37 99.18 429.36 97.97 429.08 99.09 428.48 99.08 428.41 97.87 428.13 99 427.53 98.99 427.46 97.78 427.19 98.89 426.58 98.89 426.51 97.68 426.24 98.8 425.63 98.79 425.56 97.58 425.28 98.7 424.67 98.7 424.61 98.7 424.61 97.49 424.33 98.61 423.73 98.6 423.66 97.39 423.38 98.51 422.77 98.5 422.71 98.51 422.71 97.3 422.43 98.41 421.83 98.4 421.76 98.4 421.76 97.19 421.48 98.31 420.88 98.31 420.81 97.1 420.53 98.22 419.92 98.22 419.86 97 419.58 98.12 418.98 98.11 418.91 96.91 418.63 98.03 418.02 98.02 417.96 96.81 417.68 97.92 417.07 97.92 417.01 96.71 416.73 97.83 416.12 97.83 416.06 96.61 415.77 97.73 415.17 97.73 415.11 96.52 414.83 97.64 414.22 97.63 414.15 96.42 413.88 97.55 413.27 97.54 413.21 96.32 412.92 97.44 412.32 97.44 412.25 96.23 411.97 97.35 411.37 97.34 411.3 96.12 411.02 97.25 410.41 97.24 410.35 96.03 410.07 97.15 409.47 97.15 409.4 95.93 409.12 97.06 408.51 97.06 408.45 95.84 408.17 96.96 407.56 96.96 407.5 95.74 407.22 96.87 406.61 96.86 406.55 95.64 406.27 96.76 405.66 96.76 405.6 95.55 405.32 96.67 404.71 96.67 404.65 95.45 404.37 96.57 403.76 96.57 403.76 96.56 403.7 95.35 403.41 96.48 402.81 96.47 402.75 95.25 402.46 96.38 401.85 96.37 401.79 95.16 401.51 96.28 400.91 96.28 400.85 95.06 400.56 96.19 399.96 96.18 399.89 94.96 399.61 96.09 399.01 96.08 398.95 94.86 398.67 95.99 398.05 95.98 398 94.77 397.71 95.9 397.1 95.89 397.04 94.67 396.76 95.8 396.15 95.79 396.09 94.57 395.81 95.7 395.2 95.69 395.14 94.48 394.86 95.6 394.25 95.6 394.19 94.38 393.91 95.51 393.3 95.5 393.24 94.29 392.95 95.41 392.35 95.4 392.29 94.19 392.01 95.31 391.39 95.31 391.34 94.09 391.06 95.22 390.45 95.22 390.39 93.99 390.11 95.12 389.5 95.11 389.43 93.9 389.15 95.03 388.55 95.02 388.48 93.8 388.2 94.93 387.59 94.92 387.53 93.7 387.25 94.83 386.64 94.83 386.58 93.61 386.3 94.74 385.69 94.72 385.63 93.51 385.35 94.64 384.74 94.63 384.68 93.41 384.4 94.54 383.79 94.54 383.73 93.31 383.45 94.44 382.84 94.43 382.78 93.22 382.5 94.35 381.89 94.34 381.83 93.12 381.55 94.25 380.94 94.18 380.25 76.19 384.15 88.97 431.94 98.1 430.04",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "80.35 399.71 94.08 388.27 94.83 387.64 94.92 387.57 94.92 387.53 93.7 387.25 94.83 386.64 94.83 386.58 93.61 386.3 94.74 385.69 94.72 385.63 93.51 385.35 94.64 384.74 94.63 384.68 93.79 384.49 79.47 396.42 80.35 399.71",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.82 431.55 97.26 430.22 98.47 429.2 97.97 429.08 99.09 428.48 99.08 428.41 97.87 428.13 99 427.53 98.99 427.46 97.78 427.19 98.89 426.58 98.89 426.51 97.68 426.24 98.8 425.63 98.79 425.56 98.18 425.42 90.82 431.55",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.97 414.58 97.64 414.22 97.63 414.15 97.51 414.13 96.97 414.58",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.51 426.49 96.93 418.64 97 418.58 97.81 417.91 96.81 417.68 97.92 417.07 97.92 417.01 96.71 416.73 97.83 416.12 97.83 416.06 96.61 415.77 97.73 415.17 97.73 415.11 96.64 414.86 86.63 423.19 87.51 426.49",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.75 393.71 93.3 381.58 93.77 381.19 94.23 380.81 94.18 380.25 91.88 380.75 78.31 392.06 78.75 393.71",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.46 410.17 96.03 410.07 97.15 409.47 97.15 409.4 96.39 409.23 85.36 418.42 85.57 419.24 96.46 410.17",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78 390.93 89.62 381.24 87.99 381.6 77.78 390.1 78 390.93",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89.06,404.93H92.9a2.5,2.5,0,0,1,2.5,2.5v23.14a0,0,0,0,1,0,0H86.56a0,0,0,0,1,0,0V407.43a2.5,2.5,0,0,1,2.5-2.5Z",
    transform: "translate(291.43 795.39) rotate(164.33)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.22,
    y: 403.09,
    width: 5.96,
    height: 2.36,
    transform: "translate(280.36 769.95) rotate(164.33)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.5,
    y: 378.17,
    width: 1.89,
    height: 25.44,
    transform: "translate(269.4 744.69) rotate(164.32)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.57,377s.06-4.09.18-4.12l.6-.17h0l.6-.17c.13,0,2.3,3.42,2.3,3.42l-.34,2.41-1.81.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.8,
    y: 406.68,
    width: 1.54,
    height: 19.82,
    transform: "translate(296.2 792.42) rotate(164.33)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.04,
    y: 407.46,
    width: 1.54,
    height: 19.82,
    transform: "translate(291.02 794.67) rotate(164.32)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.28,
    y: 408.23,
    width: 1.54,
    height: 19.82,
    transform: "translate(285.78 796.95) rotate(164.33)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.23,377.05h3.84a2.5,2.5,0,0,1,2.5,2.5v23.14a0,0,0,0,1,0,0H94.73a0,0,0,0,1,0,0V379.55A2.5,2.5,0,0,1,97.23,377.05Z",
    transform: "translate(19.53 -4.45) rotate(2.85)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.47,
    y: 402.67,
    width: 5.96,
    height: 2.36,
    transform: "translate(20.22 -4.4) rotate(2.85)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.81,
    y: 405.02,
    width: 1.89,
    height: 25.44,
    transform: "translate(20.93 -4.35) rotate(2.86)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.92,432.77s-1.36,3.85-1.48,3.84l-.63,0h0l-.62,0c-.13,0-1.09-4-1.09-4l1.09-2.17,1.87.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.55,
    y: 380.24,
    width: 1.54,
    height: 19.82,
    transform: "translate(19.55 -4.31) rotate(2.86)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.41,
    y: 380.38,
    width: 1.54,
    height: 19.82,
    transform: "translate(19.57 -4.46) rotate(2.86)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.28,
    y: 380.52,
    width: 1.54,
    height: 19.82,
    transform: "translate(19.53 -4.59) rotate(2.85)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.31,
    y: 380.99,
    width: 7.61,
    height: 47.21,
    transform: "translate(271.9 792.86) rotate(173.12)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.57,
    y: 376.61,
    width: 9.49,
    height: 9.49,
    transform: "translate(263.52 746.88) rotate(173.12)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.51,376.53s9-6.46,13.66-7l2,16.25L114.54,385Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "128.07 377.02 121.99 385.41 121.98 385.41 118.29 385.23 127.53 372.52 128.07 377.02",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.48,369.63l-11.23,15.45-.71,0-.16-1.38L124,370.45A14,14,0,0,1,126.48,369.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,371.36l-7.8,10.74-.14-1.13,6.39-8.8C121,371.89,121.47,371.61,122,371.36Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 122.98,
    y: 377.39,
    width: 5.82,
    height: 9.08,
    transform: "translate(62.43 -15.17) rotate(9.16)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.05,380.58l3.89.63c.59.1,3.3-2.21,5.12-1.92l2,.33c1.73.28,8.74,3.21,8,7.73s-.44,2.68-.44,2.68-.62-2.53-2.19-3.24a3.11,3.11,0,0,0-4.07,1.49,30.12,30.12,0,0,0-1.36,3.94l-7.13-1.15a26.71,26.71,0,0,0-.67-4.84c-.46-1.24-3.84-1.5-3.84-1.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.88,
    y: 391.53,
    width: 4.49,
    height: 16.19,
    transform: "translate(65.37 -16.42) rotate(9.16)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.83,
    y: 399.93,
    width: 6.68,
    height: 36.04,
    transform: "matrix(0.99, 0.16, -0.16, 0.99, 68.24, -15.71)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.08,
    y: 405.78,
    width: 67.87,
    height: 35.95,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.08,409.94c3.29-.15,6.59-.21,9.88-.27s6.58-.05,9.87-.08l9.88.08c3.29.06,6.58.12,9.87.27-3.29.14-6.58.2-9.87.26l-9.88.08c-3.29,0-6.58,0-9.87-.08S80.37,410.08,77.08,409.94Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.18,413.2c4.31-.14,8.63-.2,12.94-.26l12.94-.08,12.95.08c4.31.05,8.63.12,12.94.26-4.31.14-8.63.21-12.94.27l-12.95.07-12.94-.08C101.81,413.41,97.49,413.34,93.18,413.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133.44,418.12c-4,.14-8,.21-11.92.26l-11.92.08-11.92-.08c-4-.05-7.94-.12-11.91-.26,4-.14,7.94-.21,11.91-.26l11.92-.08,11.92.08C125.49,417.91,129.46,418,133.44,418.12Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.08,420.09c2.53-.14,5-.21,7.58-.26s5-.05,7.57-.08,5,0,7.58.08,5,.12,7.57.26c-2.52.14-5,.21-7.57.26s-5,.06-7.58.08-5,0-7.57-.08S79.61,420.23,77.08,420.09Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "77.08 422.46 84.66 422.3 92.23 422.2 107.39 422.12 122.54 422.2 130.12 422.3 137.69 422.46 130.12 422.63 122.54 422.73 107.39 422.81 92.23 422.73 84.66 422.63 77.08 422.46"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M145,424.34c-2.77.14-5.54.2-8.31.26s-5.54,0-8.31.08-5.54,0-8.3-.08-5.54-.12-8.31-.26c2.77-.15,5.54-.21,8.31-.27s5.53-.05,8.3-.08,5.54,0,8.31.08S142.18,424.2,145,424.34Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.74,427.22c2.56-.14,5.12-.21,7.68-.27s5.11-.05,7.67-.07,5.11,0,7.67.07,5.12.12,7.68.27c-2.56.14-5.12.2-7.68.26s-5.11,0-7.67.08-5.12,0-7.67-.08S105.3,427.36,102.74,427.22Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.08,432.55c4.22-.15,8.44-.21,12.65-.27l12.65-.08,12.65.08c4.21.06,8.43.12,12.65.27-4.22.14-8.44.2-12.65.26l-12.65.08-12.65-.08C85.52,432.75,81.3,432.69,77.08,432.55Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M145,436.16c-2.83.14-5.66.21-8.48.26s-5.66.05-8.49.08-5.65,0-8.48-.08-5.66-.12-8.48-.26c2.82-.14,5.65-.21,8.48-.26s5.66,0,8.48-.08,5.66,0,8.49.08S142.12,436,145,436.16Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77.08,439.19c2.37-.14,4.73-.2,7.1-.26s4.73-.05,7.09-.08,4.73,0,7.09.08,4.73.12,7.1.26c-2.37.14-4.73.21-7.1.27s-4.73.05-7.09.07-4.73,0-7.09-.08S79.45,439.33,77.08,439.19Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBug);
export default __webpack_public_path__ + "static/media/bug.f569e35fcf960a93829abf7d2e36ce8c.svg";
export { ForwardRef as ReactComponent };